import type { CivilGridFile } from '~/common/types';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

export async function addSingleFile(projectId: string, file: FormData): Promise<CivilGridFile> {
  const { data } = await axios.post(`/v2/files?projectId=${projectId}`, file);
  return data;
}

export async function deleteSingleFile(projectId: string, fileId: string): Promise<{ success?: true }> {
  const { data } = await axios.delete(`/v2/files/${fileId}?projectId=${projectId}`);

  return data;
}
